(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-comparison-table"] && !Shopify.designMode) return;
  try {
    
  class CustomerVideoPopup extends HTMLElement {
    constructor() {
      super();
      this.poster = null;
      this.overlay = null;
      this.video = null;
      this.closeBtn = null;
      this.container = null;
      this.videoData = null;
      this.isMobile = window.innerWidth < 750;
    }

    connectedCallback() {
      this.poster = this.querySelector('.adv-compare__video-poster');
      this.overlay = this.querySelector('.adv-compare__popup-overlay');
      if (!this.poster || !this.overlay) return;

      this.video = this.overlay.querySelector('.adv-compare__popup-video');
      this.closeBtn = this.overlay.querySelector('.adv-compare__popup-close');
      this.container = this.overlay.querySelector('.adv-compare__popup-container');

      var dataEl = this.querySelector('.adv-compare__video-data');
      if (dataEl) {
        try { this.videoData = JSON.parse(dataEl.textContent); } catch (e) {}
      }

      this.poster.addEventListener('click', this.openPopup.bind(this));
      this.poster.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.openPopup();
        }
      }.bind(this));

      if (this.closeBtn) this.closeBtn.addEventListener('click', this.closePopup.bind(this));

      this.overlay.addEventListener('click', function(e) {
        if (!this.container.contains(e.target)) this.closePopup();
      }.bind(this));

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && this.overlay.classList.contains('is-active')) {
          this.closePopup();
        }
      }.bind(this));

      if (this.video) {
        this.video.addEventListener('ended', this.closePopup.bind(this));
      }
    }

    loadDeviceSources() {
      if (!this.videoData || !this.video) return;
      var isMobile = window.innerWidth < 750;
      var sources = (isMobile && this.videoData.mobile) ? this.videoData.mobile : this.videoData.desktop;
      if (!sources) return;

      this.video.innerHTML = '';
      sources.forEach(function(src) {
        var sourceEl = document.createElement('source');
        sourceEl.src = src.url;
        sourceEl.type = src.type;
        this.video.appendChild(sourceEl);
      }.bind(this));
      this.video.load();
    }

    openPopup() {
      if (this.videoData && this.videoData.mobile) {
        this.loadDeviceSources();
      }
      this.overlay.classList.add('is-active');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (this.video) {
        this.video.currentTime = 0;
        this.video.play();
      }
    }

    closePopup() {
      if (this.video) {
        this.video.pause();
        this.video.currentTime = 0;
      }
      this.overlay.classList.remove('is-active');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  if (!customElements.get('customer-video-popup')) {
    customElements.define('customer-video-popup', CustomerVideoPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
